import { render, staticRenderFns } from "./EmptyBooking.vue?vue&type=template&id=77efbded&scoped=true&"
import script from "./EmptyBooking.vue?vue&type=script&lang=js&"
export * from "./EmptyBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77efbded",
  null
  
)

export default component.exports